import { render } from "./communityPolicy.vue?vue&type=template&id=34d17ca3"
import script from "./communityPolicy.vue?vue&type=script&lang=js"
export * from "./communityPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__